import { useEffect, useRef } from 'react';

/**
 * activeの間、タブを閉じる・再読み込みする前にブラウザの確認ダイアログを出す。
 *
 * beforeunloadは同期的に判定する必要があるため、activeは描画ごとにrefへ写して読む。
 * そのため、stateを変えた直後(次の描画の前)に閉じると古い値で判定されてしまう。
 * 描画を待たずに閉じたい場合は、返り値のcloseWindowを使うこと。
 */
export const useBeforeUnloadGuard = (active: boolean) => {
    const activeRef = useRef(active);
    activeRef.current = active;
    // closeWindowで閉じる間だけ、activeによらず確認を出さない
    const releasedRef = useRef(false);

    useEffect(() => {
        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            if (!activeRef.current || releasedRef.current) return;
            e.preventDefault();
            // 旧仕様のブラウザ向け。表示される文言はブラウザ既定のものになる
            e.returnValue = "";
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => window.removeEventListener("beforeunload", handleBeforeUnload);
    }, []);

    /**
     * 確認を出さずにタブを閉じる。
     * スクリプトから開いたタブでなければブラウザが閉じるのを拒むため、その場合はfalseを返す
     */
    const closeWindow = (): boolean => {
        releasedRef.current = true;
        window.close();
        // 閉じるのが許可された場合、window.closedは同期的にtrueになる
        if (window.closed) return true;

        releasedRef.current = false;
        return false;
    };

    return { closeWindow };
};
